<template>
  <div v-if="textKeys.length > 0" class="ds-text-key-docs">
    <dl class="dl mts">
      <template v-for="(tk, idx) in textKeys" :key="'dt-' + idx">
        <dt class="dt">{{ tk.type }}</dt>
        <dd class="dd" v-html="tk.desc"></dd>
      </template>
    </dl>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { TextKeyDoc, GlueDocs } from "./glue-documentation-types";

@Component({ name: "text-key-docs" })
export default class GlueDocDisplayOptions extends Vue {
  @Prop(String)
  public readonly componentName!: string;

  get textKeys(): TextKeyDoc[] {
    const doc: GlueDocs = window[this.componentName + "-docs"];
    if (doc != null) {
      if (doc.textKeys) {
        return doc.textKeys;
      }
    }
    return [];
  }
}
</script>
